import {
    LIST_CUSTOMER_LOAN,
    SAVE_CUSTOMER_LOAN,
    STORE_CUSTOMER_LOAN,
    STORE_BORROWERS,
    STORE_BORROWER,
    REMOVE_BORROWER,
    CREATE_BORROWER,
    EDIT_BORROWER,
    ADD_TRANSACTION,
    EDIT_TRANSACTION,
    DELETE_TRANSACTION,
    DELETE_BORROWER,
} from '../../constants/loan';

// --- Legacy actions (kept for any other consumers) ---------------------------

export const saveCustomerLoan = (data, callback) => ({
    type: SAVE_CUSTOMER_LOAN,
    data,
    callback,
});

export const listCustomerLoan = (data) => ({
    type: LIST_CUSTOMER_LOAN,
    data,
});

export const storeCustomerLoan = (loanHistory) => ({
    type: STORE_CUSTOMER_LOAN,
    loanHistory,
});

// --- New v1.0 borrower actions ----------------------------------------------

export const storeBorrowers = (payload) => ({
    type: STORE_BORROWERS,
    payload,
});

export const storeBorrower = (borrower) => ({
    type: STORE_BORROWER,
    borrower,
});

export const removeBorrower = (borrowerId) => ({
    type: REMOVE_BORROWER,
    borrowerId,
});

export const createBorrower = (data, callback) => ({
    type: CREATE_BORROWER,
    data,
    callback,
});

export const editBorrower = (data, callback) => ({
    type: EDIT_BORROWER,
    data,
    callback,
});

export const addTransaction = (data, callback) => ({
    type: ADD_TRANSACTION,
    data,
    callback,
});

export const editTransaction = (data, callback) => ({
    type: EDIT_TRANSACTION,
    data,
    callback,
});

export const deleteTransaction = (data, callback) => ({
    type: DELETE_TRANSACTION,
    data,
    callback,
});

export const deleteBorrower = (data, callback) => ({
    type: DELETE_BORROWER,
    data,
    callback,
});
